// project imports
import MinimalLayout from 'layout/MinimalLayout';
import Login from '../views/pages/authentication/authentication3/Login3';

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: '/login',
      element: <Login />
    }
  ]
};

export default AuthenticationRoutes;
